import { Venue } from "@greeter/core";

const mockVenue: Venue = {
  ...Venue.createDefault(),
  address: {
    street: "Jomfru Ane Gade 1",
    city: "Aalborg",
    postalCode: "9000",
    country: "Denmark"
  },
  logoUrl: "http://placekitten.com/g/300/300",
};
export { mockVenue };
